import { CssBaseline } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";

function App() {
    return (
        <AuthProvider>
            {/* ✅ CssBaseline acts as an aggressive reset for Material-UI, stripping all default browser margins/borders */}
            <CssBaseline />
            <AppRoutes />
        </AuthProvider>
    );
}

export default App;